import React from "react";
import { Tag } from "antd";
import { BiPhone, BiSelectMultiple } from "react-icons/bi";
import { TiCancel } from "react-icons/ti";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { VscWarning } from "react-icons/vsc";
import { ImLoop2 } from "react-icons/im";
import { countryList } from "./listsLabels";
import moment from "moment";
import dayjs from "./dayjs";
import { FaCheck, FaCheckDouble, FaExclamationTriangle } from "react-icons/fa";
import { MdOutlineDangerous } from "react-icons/md";
import { AiOutlineGateway } from "react-icons/ai";
import { BsFillShareFill } from "react-icons/bs";
import { PhoneOutlined } from "@ant-design/icons";
import { normalizePhoneForDial, normalizePhonesForDial } from "./phoneUtils";

export const PORT_BACKEND = ":8080";

export const rootUrlLocalhost = `http://localhost${PORT_BACKEND}/`;
// export const rootUrlLocalhost = `http://172.22.22.60${PORT_BACKEND}/`;
// export const rootUrlLocalhost = ` http://192.168.188.47${PORT_BACKEND}/`;
// export const rootUrlLocalhost = `http://10.0.0.247${PORT_BACKEND}/`;
export const rootUrlProd = "https://oseo-dev.jcloud.ik-server.com/";
export const daysJsFormat = {
  day: "DD.MM.YYYY",
  hour: "HH:mm",
  full: "DD.MM.YYYY, HH:mm",
  fullMs: "DD.MM.YYYY, HH:mm:ss SSS",
  fullTZ: "DD.MM.YYYY, HH:mm tz",
  abacus: "YYYY-MM-DD",
};

export const googleApiKey = "AIzaSyA8hPUl08iapUT_TsXzj9Kxk7oq0gylHos";
export const tomtomApiKey = "vMyYV0KVONTYu5g8xryH230qTIL2wEeV";

export const localStorageUserKey = "oseo_user_token";

// https://avic-staging.tcf-dev.com/
// https://avic.tcf-dev.com/
const apisUrl = [
  {
    url: "https://oseo-staging.jcloud.ik-server.com/",
    env: "staging",
    match: ["avic-staging.tcf-dev"],
  },
  {
    url: "https://oseo-dev.jcloud.ik-server.com/",
    env: "development",
    match: ["avic-dev.tcf-dev", "localhost"],
  },
  {
    url: "https://oseo-staging.jcloud.ik-server.com/",
    env: "development",
    match: ["avic.tcf-dev"],
  },
  {
    url: "https://oseo-production.jcloud.ik-server.com/",
    env: "production",
    match: ["avic.oseo-vs"],
  },
  {
    url: "https://oseo-production.jcloud.ik-server.com/",
    env: "production",
    match: ["avic-beta.oseo-vs"],
  },
];

const matchUrl = (url, match) => {
  return match.some(str => url.includes(str));
};

export const dbEnv = (show = false) => {
  const currentUrl = window.location.href;

  const matchedUrl = apisUrl.find(api => matchUrl(currentUrl, api.match));

  if (matchedUrl === undefined) {
    return "";
  }

  if (matchedUrl.env === "production") {
    return "";
  } else {
    if (matchedUrl) {
      return show ? matchedUrl : matchedUrl.env;
    } else {
      return "No db";
    }
  }
};

export const apiUrl = () => {
  if (process === undefined || process?.env?.NODE_ENV === "development") {
    return `${rootUrlLocalhost}api`;
  } else {
    // Window url
    const currentUrl = window.location.href;

    const matchedUrl = apisUrl.find(api => matchUrl(currentUrl, api.match));

    if (matchedUrl) {
      return matchedUrl.url + "api";
    } else {
      alert("No url found, setup the backend please");
      return "";
    }
  }
};

export const colors = {
  available: "#1890ff",
  reserved: "#0050b3",
  selected: "#0e801f",
  rentedSold: "#bfbfbf",
  primary: "#4F46E5", // Disponible
  secondary: "#E59246", // réservé
  gray: "#A5A5A5", // rented
  blue: "#0a4b67", // rented
  lightgray: "#e0e0e0",
  mainRed: "#FA3B3B",
  black: "#2f2f2f",
  blackLight: "#606060",
};
export const formatCurrency = value => {
  if (value === "-") {
    return value;
  } else {
    if (value === undefined || value === null || value === 0 || value === "0") {
      return 0.0;
    } else {
      let fixed = Number(value)
        .arrondi2Decimal(2)
        .toString();

      let amount;

      const parts = fixed.split(".");
      if (parts.length === 1) {
        amount = `${fixed}.00`;
      } else {
        const decimalPart = parts[1].length === 1 ? `${parts[1]}0` : parts[1];
        amount = `${parts[0]}.${decimalPart}`;
      }

      let valueReturned = amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return `CHF ${valueReturned}`;
    }
  }
};

export const listProfiles = [
  {
    value: "institution",
    label: "Je représente une institution",
    color: "#FF0001",
  },
  {
    value: "mandant",
    label: "Je représente une organisation",
    color: "#FF0001",
  },
  { value: "interprete", label: "Je suis un interprète", color: "#000000" },
];

export const rolesAccess = {
  ghost: 0,

  interprete: 1,

  insitutionAdmin: 3,
  institutionFinance: 3,
  institutionDemander: 3,
  institutionIntervenant: 3,

  institution: 3,
  mandant: 3, // Que facturation

  permanance: 4,
  admin: 5,
};

export const roles = {
  ghost: "ghost",

  applicant: "applicant",
  intervenant: "intervenant",

  admin: "admin",

  superAdmin: "superAdmin",

  mandant: "mandant", //
  institution: "institution",

  user: "user",

  interprete: "interprete",
  permanance: "permanance",
};

export const listRoles = [
  { key: roles.admin, label: "Admin" },
  { key: roles.permanance, label: "Permanence" },
  { key: roles.interprete, label: "Interprète" },
  { key: roles.mandant, label: "Mandant" },
  { key: roles.institution, label: "Institution" },
  { key: roles.user, label: "Utilisateur" },
  { key: roles.intervenant, label: "Intervenant" },
];

export const subRoles = {
  institutionAdmin: "institutionAdmin",
  institutionFinance: "institutionFinance",
  institutionDemander: "institutionDemander", // applicant
  // institutionIntervenant: "institutionIntervenant",
};

export const canDoActions = {
  create: "create",
  read: "read",
  update: "update",
  delete: "delete",
};

export const buttonsLabels = {
  save: "Sauvegarder",
};

export const institutionTypeDomaine = [
  { label: "Santé - Réadaptation ou thérapie", value: "sante" },
  { label: "Police", value: "police" },
  { label: "Immigration", value: "immigration" },
  { label: "Juridique", value: "juridique" },
];

export const days = [
  { label: "Lundi", value: "monday" },
  { label: "Mardi", value: "tuesday" },
  { label: "Mercredi", value: "wednesday" },
  { label: "Jeudi", value: "thursday" },
  { label: "Vendredi", value: "friday" },
  { label: "Samedi", value: "saturday" },
  { label: "Dimanche", value: "sunday" },
];
export const renderDay = day => days.find(e => e.value === day).label;

export const renderUserName = user => {
  if (user === null) {
    return "";
  }
  return `${user?.info?.lastname} ${user?.info?.firstname}`;
};

export const renderLangueInterprete = interprete => {
  const fullLabels = interprete?.interpreteData?.languages.map(ln => {
    return languagesList.find(e => e.value === ln)?.label;
  });

  if (
    fullLabels === undefined ||
    fullLabels === null ||
    fullLabels.length === 0
  ) {
    return "";
  }

  return `(${fullLabels.join(", ")})`;
};

export const renderUserNameEmail = user => {
  if (user === null) {
    return "";
  }
  return `${user?.info?.lastname} ${user?.info?.firstname} ${
    user?.email ? "- " + user?.email : ""
  }`;
};

export const renderUserLastname = user => {
  return ` ${user.info.lastname}`;
};

export const renderUserGenderShort = user => {
  if (user.info.genre === "female") {
    return "F";
  } else if (user.info.genre === "male") {
    return "H";
  } else {
    return "-";
  }
};

export const renderUserLanguagesShort = user => {
  const languages = user.interpreteData.languages.map(l => l);
  const concatenatedLanguages = languages.join(", ");
  const uppercasedLanguages = concatenatedLanguages.toUpperCase();
  return uppercasedLanguages;
};

export const renderUserLanguagesLong = user => {
  const array = user.interpreteData.languages.map(ln => {
    return languagesList.find(e => e.value === ln)?.label;
  });

  const concatenatedLanguages = array.join(", ");
  const uppercasedLanguages = concatenatedLanguages;
  return uppercasedLanguages;
};

export const renderUserFirstname = user => {
  return `${user.info.firstname}`;
};

export const renderUserGender = user => {
  if (user?.info?.genre === "female") {
    return "Femme";
  } else if (user?.info?.genre === "male") {
    return "Homme";
  } else {
    return "-";
  }
};

export const typeIntervention = {
  visio: "visio",
  phone: "phone",
  in_person: "in_person",
};

export const modeInterpretariat = [
  { label: "Par visio-conférence", value: typeIntervention.visio },
  { label: "Par téléphone", value: typeIntervention.phone },
  { label: "En personne", value: typeIntervention.in_person },
];

export const isExternal = [
  { label: "ouio", value: true },
  { label: "non", value: false },
];

export const diplomas = [
  { label: "Brevet", value: "licence" },
  { label: "Certificat", value: "certificate" },
  { label: "Aucun diplôme", value: "none" },
];

export const subRolesCheckbox = [
  {
    value: subRoles.institutionAdmin,
    key: subRoles.institutionAdmin,
    label: "Administrateur",
    description:
      "Ce role permet d’ajouter d’autres utilisateurs à l’institution, ainsi que la modification des informations générales de l’institution",
  },
  {
    value: subRoles.institutionDemander,
    key: subRoles.institutionDemander,
    label: "Demandeur",
    description:
      "Ce role permet de créer et gérer vos commandes de prestations. ",
  },
  {
    value: subRoles.institutionFinance,
    key: subRoles.institutionFinance,
    label: "Facturation",
    description:
      "Ce role permet d’acceder et gérer les factures relatives aux prestations. ",
  },
  // {
  //   value: subRoles.institutionIntervenant,
  //   key: subRoles.institutionIntervenant,
  //   label: "Responsable de l'entretien",
  //   description:
  //     "Ce role permet de signer et quittancer les prestations d’interpretariat. Ce role ne permet pas de se connecter sur la plateforme.",
  // },
];

export const levels = [
  {
    value: "expert",
    // label: "Expert",
    label: "Très expérimenté",
    // description: "Formation avancée AVIC avec 5 années au moins d'expérience",
  },
  {
    value: "intermediate",
    // label: "Intermédiaire",
    label: "Expérimenté ",
    // description: "Formation avancée AVIC entre 1 et 4 années d'expérience ",
  },
  {
    value: "standard",
    label: "Standard",
    // description: "Formation de base AVIC avec moins d'une année d'expérience",
  },
];

export const languagesList = [
  { label: "Français", value: "fr" },
  { label: "Anglais", value: "en" },
  { label: "Chinois mandarin", value: "zh" },
  { label: "Espagnol", value: "es" },
  { label: "Hindi", value: "hi" },
  { label: "Arabe", value: "ar" },
  { label: "Arabe maghrébin", value: "ary" },
  { label: "Bengali", value: "bn" },
  { label: "Russe", value: "ru" },
  { label: "Portugais", value: "pt" },
  { label: "Indonésien", value: "id" },
  { label: "Ourdou", value: "ur" },
  { label: "Allemand", value: "de" },
  { label: "Japonais", value: "ja" },
  { label: "Swahili", value: "sw" },
  { label: "Marathi", value: "mr" },
  { label: "Télougou", value: "te" },
  { label: "Turc", value: "tr" },
  { label: "Coréen", value: "ko" },
  { label: "Tamoul", value: "ta" },
  { label: "Italien", value: "it" },
  { label: "Yoruba", value: "yo" },
  { label: "Thaï", value: "th" },
  { label: "Tatar", value: "tt" },
  { label: "Gujarati", value: "gu" },
  { label: "Javanais", value: "jv" },
  { label: "Polonais", value: "pl" },
  { label: "Ukrainien", value: "uk" },
  // { label: "Russe-Ukrainien", value: "ru-ua" },
  { label: "Kannada", value: "kn" },
  { label: "Xhosa", value: "xh" },
  { label: "Malayalam", value: "ml" },
  { label: "Sundanais", value: "su" },
  { label: "Odia (Oriya)", value: "or" },
  { label: "Néerlandais", value: "nl" },
  { label: "Roumain", value: "ro" },
  { label: "Maithili", value: "mai" },
  { label: "Haoussa", value: "ha" },
  { label: "Birman", value: "my" },
  { label: "Azéri", value: "az" },
  { label: "Amharique", value: "am" },
  { label: "Sindhi", value: "sd" },
  { label: "Chinois gan", value: "gan" },
  { label: "Cingalais (Sinhala)", value: "si" },
  { label: "Serbo-croate-bosniaque", value: "sh" },
  { label: "Népalais", value: "ne" },
  { label: "Grec", value: "el" },
  { label: "Chittagonian", value: "ctg" },
  { label: "Assamais", value: "as" },
  { label: "Saraiki", value: "skr" },
  { label: "Nouar", value: "noa" },
  { label: "Chinois hakka", value: "hak" },
  { label: "Avar", value: "av" },
  { label: "Tchèque", value: "cs", archived: true },
  { label: "Chinois wu", value: "wuu" },
  { label: "Chinois jin", value: "cjy" },
  { label: "Chinois cantonais", value: "yue" },
  { label: "Chinois minbei", value: "nan" },
  { label: "Chinois xiang", value: "hsn" },
  { label: "Amazighe", value: "ber" },
  { label: "Chinois jinyu", value: "cjv" },
  { label: "Rwandais", value: "rw" },
  { label: "Bhojpuri", value: "bho" },
  { label: "São Toméen", value: "stp" },
  { label: "Baloutche", value: "bal" },
  { label: "Ouzbek", value: "uz" },
  { label: "Tchétchène", value: "ce" },
  { label: "Kazakh", value: "kk" },
  { label: "Géorgien", value: "ka" },
  { label: "Ewe", value: "ee" },
  { label: "Kirghize", value: "ky" },
  { label: "Tadjik", value: "tg" },
  { label: "Kachoube", value: "csb" },
  { label: "Shan", value: "shn" },
  { label: "Kannada toulou", value: "kfn" },
  { label: "Comorien", value: "swb" },
  { label: "Yao", value: "yao" },
  { label: "Kirundi", value: "rn" },
  { label: "Akan", value: "ak", archived: true },
  { label: "Malais", value: "ms" },
  { label: "Farsi / Persan", value: "fa" }, // Fusionné Farsi et Persan
  { label: "Wolof", value: "wo" }, // Fusionné Wolof et Sénégalais
  { label: "Sénégalais", value: "sen" }, // Fusionné Wolof et Sénégalais
  { label: "Somali", value: "so" },
  { label: "Kurde kurmanji", value: "kmr" },
  { label: "Kurde", value: "kur", archived: true },
  { label: "Kurde badini", value: "ku" },
  { label: "Kurde zazaki", value: "zza" },
  { label: "Kurde sorani", value: "ckb" },
  { label: "Dari", value: "prs" },
  { label: "Albanais", value: "sq" },
  { label: "Tigrinya", value: "ti" },
  { label: "Bulgare", value: "bg" },
  { label: "Hassanya", value: "mey" },
  { label: "Macédonien", value: "mk" },
  { label: "Peul / Fulfulde / Pulaar", value: "ff" },
  { label: "Serbe", value: "sr", archived: true },
  { label: "Croate", value: "hr", archived: true },
  { label: "Bosniaque", value: "bs", archived: true },
  { label: "Suédois", value: "sv" },
  { label: "Catalan", value: "ca" },
  { label: "Lingala", value: "ln" },
  { label: "Pachto", value: "ps" },
  { label: "Pendjabi", value: "pa" },
  { label: "Slovaque", value: "sk" },
  { label: "Saho", value: "ssy" },
  { label: "Arménien", value: "hy" },
  { label: "Hongrois", value: "hu" },
  { label: "Peul", value: "pov" },
  { label: "Vietnamien", value: "vi" },
  { label: "Mongole", value: "mn" },
];

export const statusPrestationsValues = {
  draft: "draft",
  waiting: "waiting",
  noReply: "noReply",
  planned: "planned",
  cancelClient: "cancelClient",
  cancelAvic: "cancelAvic",
  cancelInterprete: "cancelInterprete",
  cancel: "cancel",
  finish: "finish",
  finish_notsigned: "finish_notsigned",
  finish_permanance: "finish_permanance",
};

// controlled, refused, hidden, waiting
export const statusControl = {
  controlled: "controlled",
  refused: "refused",
  waiting: "waiting",
  uncontrolled: "uncontrolled",
};

export const statusControlList = [
  {
    label: "Contrôlé",
    value: statusControl.controlled,
    color: "green-inverse",
  },
  {
    label: "En attente",
    value: statusControl.waiting,
    color: "orange-inverse",
  },
  {
    label: "Non contrôlé",
    value: statusControl.uncontrolled,
    color: "gray-inverse",
  },
];

export const subStatus = {
  follow: "follow",
  not_signed: "not_signed",
  expired: "expired",
  signed: "signed",
  interprete: "interprete", // cancel
  interprete_changes: "interprete_changes", // LEGACY DO NOT USE IT
  permanance: "permanance", // cancel
  institution: "institution", // cancel
  duplicate: "duplicate", // cancel
};
export const subStatusPrestations = [
  {
    label: "Suivi",
    text: "Suivi",
    value: subStatus.follow,
    color: "#c9c407",
  },
  {
    label: "Permanence",
    text: "Permanence",
    value: subStatus.permanance,
    color: "rgba(238,128,93,0.88)",
  },
  {
    label: "Client",
    text: "Client",
    value: subStatus.institution,
    color: "#134080",
  },
  {
    label: "Expirée",
    text: "Expirée",
    value: subStatus.expired,
    color: "rgba(179,0,215,0.94)",
  },
  {
    label: "Signé",
    text: "Signé",
    value: subStatus.signed,
    color: "#b21732",
  },
  {
    label: "Dupliqué",
    text: "Dupliqué",
    value: subStatus.duplicate,
    color: "#0e3b77",
  },
  {
    label: "Non Signé",
    text: "Non Signé",
    value: subStatus.not_signed,
    color: "rgba(119,27,122,0.93)",
  },
  {
    label: "Interprète",
    text: "Interprète",
    value: subStatus.interprete,
    color: "#168830",
  },
  // {
  //   label: "Interprète",
  //   text: "Interprète",
  //   value: subStatus.interprete_changes,
  //   color: "#168830",
  // },
];

export const statusPrestations = [
  {
    label: "Brouillon",
    text: "Brouillon",
    value: statusPrestationsValues.draft,
    color: "#16a817",
  },
  {
    label: "En attente de réponse",
    text: "En attente de réponse",
    value: statusPrestationsValues.waiting,
    color: "volcano",
  },
  {
    label: "Sans réponse",
    text: "Sans réponse",
    value: statusPrestationsValues.noReply,
    color: "purple-inverse",
  },
  {
    label: "Prévue",
    text: "Prévue",
    value: statusPrestationsValues.planned,
    color: colors.mainRed,
  },
  // { label: "A signé", value: "toSigned", color: "#767676" },
  {
    label: "Annulée",
    text: "Annulée",
    value: statusPrestationsValues.cancel,
    color: "grey",
  },
  {
    label: "Annulé (client)",
    text: "Annulé (client)",
    value: statusPrestationsValues.cancelClient,
    color: "#D6D6D6",
  },
  {
    label: "Annulé (interprète)",
    text: "Annulé (interprète)",
    value: statusPrestationsValues.cancelInterprete,
    color: "#D6D6D6",
  },
  {
    label: "Annulé (AVIC)",
    text: "Annulé (AVIC)",
    value: statusPrestationsValues.cancelAvic,
    color: "#D6D6D6",
  },
  {
    label: "Terminé",
    text: "Terminé",
    value: statusPrestationsValues.finish,
    color: "#000",
  },
  {
    label: "Terminé (non signé)",
    text: "Terminé (non signé)",
    value: statusPrestationsValues.finish_notsigned,
    color: "#3f3636",
  },
  {
    label: "Terminé (permanence)",
    text: "Terminé (permanence)",
    value: statusPrestationsValues.finish_permanance,
    color: "#545454",
  },
];

export const statusPrestationsActual = statusPrestations.filter(o => {
  return ![
    statusPrestationsValues.cancelClient,
    statusPrestationsValues.cancelInterprete,
    statusPrestationsValues.cancelAvic,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(o.value);
});

export const renderStatusPrestation = (
  prestation,
  params = { showControls: false },
) => {
  try {
    const {
      status,
      control2,
      control1,
      subStatus: subStatusValue,
      isFollow,
      batch_grouped,
      isSequentialPrestation,
      batch_shared,
    } = prestation;

    const { showControls } = params;

    let stat = statusPrestations.find(s => s.value === status);
    let subTag = null;
    let subTagFollow = null;
    if (subStatusValue !== null) {
      subTag = subStatusPrestations.find(s => s.value === subStatusValue);
    }

    if (isFollow === true) {
      subTagFollow = subStatusPrestations.find(
        s => s.value === subStatus.follow,
      );
    }

    return (
      <div
        className={"status-tags-wrapper"}
        key={stat.label + prestation._id + "status"}
        style={{}}
      >
        <Tag size={"middle"} color={stat.color}>
          {stat.label}
        </Tag>

        {subTag !== null && (
          <Tag size={"middle"} color={subTag?.color}>
            {subTag?.label}
          </Tag>
        )}

        {subTagFollow !== null && (
          <Tag size={"middle"} color={subTagFollow.color}>
            {subTagFollow.label}
          </Tag>
        )}

        {showControls &&
        control1 &&
        control1.status !== statusControl.uncontrolled ? (
          <Tag
            size={"middle"}
            color={colorsSwitchStatusControl(control1.status)}
            icon={iconSwitchStatusControl(control1.status, 1, 15)}
          ></Tag>
        ) : null}

        {showControls &&
        control2 &&
        control2.status !== statusControl.uncontrolled ? (
          <Tag
            size={"middle"}
            color={colorsSwitchStatusControl(control2.status)}
            icon={iconSwitchStatusControl(control2.status, 2, 15)}
          ></Tag>
        ) : null}

        {batch_shared !== undefined && batch_shared !== null && (
          <Tag size={"middle"} color={"rgba(8,107,15,0.84)"}>
            <BsFillShareFill
              size={14}
              style={{ marginTop: -3, padding: 0, marginRight: 5 }}
            />
            Partagée
          </Tag>
        )}

        {isSequentialPrestation === true && (
          <Tag size={"middle"} color={"green-inverse"}>
            Courte
          </Tag>
        )}
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};
export const renderStatusTag = (
  status,
  subStatusRecord = null,
  isFollow = null,
  control = {},
) => {
  try {
    let stat = statusPrestations.find(s => s.value === status);
    let subTag = null;
    let subTagFollow = null;
    if (subStatusRecord !== null) {
      subTag = subStatusPrestations.find(s => s.value === subStatusRecord);
    }

    if (isFollow === true) {
      subTagFollow = subStatusPrestations.find(
        s => s.value === subStatus.follow,
      );
    }

    return (
      <div key={stat.label + subTag?.label + subTagFollow?.label}>
        <Tag size={"middle"} color={stat.color}>
          {stat.label}
        </Tag>

        {subTag !== null && (
          <Tag size={"middle"} color={subTag?.color}>
            {subTag?.label}
          </Tag>
        )}

        {subTagFollow !== null && (
          <Tag size={"middle"} color={subTagFollow.color}>
            {subTagFollow.label}
          </Tag>
        )}

        {control.control1 &&
        control.control1.status !== statusControl.uncontrolled ? (
          <Tag
            size={"middle"}
            color={colorsSwitchStatusControl(control.control1.status)}
            icon={iconSwitchStatusControl(control.control1.status, 1, 15)}
          ></Tag>
        ) : null}

        {control.control2 &&
        control.control2.status !== statusControl.uncontrolled ? (
          <Tag
            size={"middle"}
            color={colorsSwitchStatusControl(control.control2.status)}
            icon={iconSwitchStatusControl(control.control2.status, 2, 15)}
          ></Tag>
        ) : null}
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};

export const renderStatusLabels = (
  status,
  subStatusRecord = null,
  isFollow = null,
) => {
  try {
    let stat = statusPrestations.find(s => s.value === status);
    let subTag = null;
    let subTagFollow = null;
    if (subStatusRecord !== null) {
      subTag = subStatusPrestations.find(s => s.value === subStatusRecord);
    }

    if (isFollow === true) {
      subTagFollow = subStatusPrestations.find(
        s => s.value === subStatus.follow,
      );
    }

    let str = [];

    str.push(stat.label);

    if (subTag) {
      str.push(subTag.label);
    }

    if (subTagFollow) {
      str.push(subTagFollow.label);
    }

    return str.join(", ");
  } catch (e) {
    console.log(e);
  }
};

export const statusOption = [
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.mainRed,
        }}
      >
        <IoIosCheckmarkCircleOutline size={20} style={{ marginRight: 6 }} />
        Inviter
      </span>
    ),
    value: "invited",
  },
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.selected,
        }}
      >
        <BiSelectMultiple size={15} style={{ marginRight: 6 }} />
        Attribuer
      </span>
    ),
    value: "selected",
  },
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.blackLight,
        }}
      >
        <TiCancel size={20} style={{ marginRight: 6 }} />
        Ne pas inviter
      </span>
    ),
    value: "not_invited",
  },
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.black,
        }}
      >
        <TiCancel size={20} style={{ marginRight: 6 }} />
        Refusé
      </span>
    ),
    value: "refused",
    disabled: true,
  },
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.black,
        }}
      >
        <TiCancel size={20} style={{ marginRight: 6 }} />
        Non disponible
      </span>
    ),
    value: "not_available",
  },
  // {
  //   label: () => (
  //     <span
  //       className={"item-color-select"}
  //       style={{
  //         backgroundColor: colors.available,
  //       }}
  //     >
  //       <VscWarning size={20} style={{ marginRight: 6 }} />
  //       Prioritaire
  //     </span>
  //   ),
  //   value: "rented",
  // },
  {
    label: () => (
      <span
        className={"item-color-select"}
        style={{
          backgroundColor: colors.secondary,
        }}
      >
        <ImLoop2 size={15} style={{ marginRight: 6 }} />
        Relance
      </span>
    ),
    value: "relance",
  },
];

export const renderDiplomas = (interprete = "") => {
  return (
    diplomas.find(e => e.value === interprete?.interpreteData?.diplomas)
      ?.label || ""
  );
};

export const renderLevel = (interprete = "") => {
  return (
    levels.find(e => e.value === interprete?.interpreteData?.level)?.label ||
    "-"
  );
};

export const renderInterpreteCountry = interprete => {
  return countryList.find(e => e?.value === interprete?.interpreteData?.country)
    .label;
};

export const renderTypePrestation = type => {
  return modeInterpretariat.find(e => e.value === type)?.label;
};

export const renderMonthByLetter = number => {
  // Configurer Day.js en français

  // Créer une date avec le mois spécifié. L'année n'est pas importante ici.
  // Day.js utilise également des mois basés sur zéro (0-11), donc on soustrait 1
  const date = dayjs(`2021-${number}`, "YYYY-M");

  // Renvoyer le nom du mois en français
  return date.format("MMMM"); // 'MMMM' renvoie le nom complet du mois
};

export const generateSelectContent = () => {
  let current = dayjs("2023-10"); // Commencer en octobre 2023
  const today = dayjs().add(1, "month"); // Date actuelle
  const months = [];
  const years = new Set();

  while (current.isBefore(today) || current.isSame(today, "month")) {
    months.push({
      label: current.format("MMMM"),
      value: current.month() + 1, // Day.js utilise des mois basés sur zéro
    });
    years.add(current.year());

    current = current.add(1, "month"); // Ajouter un mois à chaque itération
  }

  let yearsList = Array.from(years).map(year => ({
    label: year,
    value: year,
  }));

  return {
    monthsSelectContent: months,
    yearsSelectContent: yearsList.sort((a, b) => b.value - a.value),
  };
};

export const isUrgent = prestation => {
  const applicationAt = dayjs(prestation.applicationAt);
  const startDate = dayjs(prestation.finalStartDate);
  return startDate.diff(applicationAt, "hours") < 24;
};

export function getKeyFormattedAddress(dataObject, key) {
  const addressComponents = dataObject.data.results[0].address_components;

  for (const component of addressComponents) {
    if (component.types.includes(key)) {
      return component.long_name;
    }
  }
}

export function getFormattedAddress(dataObject) {
  if (dataObject === undefined) {
    return "";
  }
  // Extract address components from the object
  const addressComponents = dataObject?.data?.results[0].address_components;

  // Initialize variables to hold desired components
  let streetNumber = "";
  let street = "";
  let postalCode = "";
  let city = "";

  // Loop through the address components to extract required details
  for (const component of addressComponents) {
    if (component.types.includes("street_number")) {
      streetNumber = component.long_name;
    }
    if (component.types.includes("route")) {
      street = component.long_name;
    }
    if (component.types.includes("postal_code")) {
      postalCode = component.long_name;
    }
    if (component.types.includes("locality")) {
      city = component.long_name;
    }
  }

  // Construct the desired formatted address
  const formattedAddress = `${street} ${streetNumber}, ${postalCode} ${city}`;

  return formattedAddress;
}

export const renderTravel = (cost, costParams, billing) => {
  // const renderTravel = (cost, item) => {
  //   // dec they ask for it
  //   // 11.01.24 they ask to removed it. thanks but no thanks.
  //
  //   const extraFromDe = `De ${getKeyFormattedAddress(
  //     item?.costParams?.driving?.originCoords,
  //     "locality",
  //   )}  à `;
  //
  //   return `${item?.billing?.beneficiary},  \n ${getFormattedAddress(
  //     item?.costParams?.driving?.destCoords,
  //   )}.  \n ${cost?.tranches}km x 80cts / km`;
  // };
  // old since 07.03.254
  //
  //   return `${billing?.beneficiary},  \n ${getFormattedAddress(
  //     costParams?.driving?.destCoords,
  //   )}.  \n ${cost?.tranches}km x 80cts / km`;

  return cost.description;
};

export const typeSwitchStatusControl = status => {
  switch (status) {
    case statusControl.controlled:
      return "success";
    // case statusControl.refused:
    //   return "error";
    case statusControl.waiting:
      return "warning";
    default:
      return "info";
  }
};

export const colorsSwitchStatusControl = status => {
  switch (status) {
    case statusControl.controlled:
      return "green-inverse";
    // case statusControl.refused:
    //   return "red-inverse";
    case statusControl.waiting:
      return "orange-inverse";
    default:
      return "info";
  }
};

export const iconSwitchStatusControl = (status, level, size = 25) => {
  switch (status) {
    case statusControl.controlled:
      if (level === 1) {
        return <FaCheck size={size} />;
      }

      if (level === 2) {
        return <FaCheckDouble size={size} />;
      }
    case statusControl.refused:
      return <MdOutlineDangerous size={size + 3} />;
    case statusControl.waiting:
      return <FaExclamationTriangle size={size} />;
    default:
      return "info";
  }
};

export const renderResponsable = (responsable = {}) => {
  const { lastname = "", firstname = "", role = "" } = responsable;
  return `${lastname} ${firstname}  ${
    role !== undefined && role?.length > 0 ? `, ${role}` : ""
  }`;
};

export const renderBeneficiary = (beneficiary = {}) => {
  return `${beneficiary.firstname} ${beneficiary.lastname} ${beneficiary.reference}`;
};

export const renderPhoneClickable = (phone = "") => {
  if (phone === null || phone === "" || phone.length < 1) {
    return null;
  }

  const dialNumbers = normalizePhonesForDial(phone);

  if (dialNumbers.length === 0) {
    return null;
  }

  if (dialNumbers.length === 1) {
    return (
      <a href={`tel:${dialNumbers[0]}`}>
        <BiPhone style={{ fontSize: 18 }} />
        Appeler
      </a>
    );
  }

  return (
    <>
      {dialNumbers.map((dialNumber, index) => (
        <React.Fragment key={`${dialNumber}-${index}`}>
          <a href={`tel:${dialNumber}`}>
            <BiPhone style={{ fontSize: 18 }} />
            Appeler {index + 1}
          </a>
          {index < dialNumbers.length - 1 ? " / " : null}
        </React.Fragment>
      ))}
    </>
  );
};

export const renderEmailClickable = (email = "") => {
  return <a href={`mailto:${email}`}>{email}</a>;
};

export const monthNames = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

export const isInstitutionGrouped = (institution, prestation = {}) => {
  if (institution === undefined || institution === null) {
    return false;
  }
  const { groupedBilling, _id, billings } = institution;
  const { finalStartDate = null, finalEndDate } = prestation;

  if (
    typeof institution === "number" ||
    typeof institution === "string" ||
    _id === undefined
  ) {
    console.error("Need to be an object instance");
    return false; // Return false or handle as per your requirement
  }

  if (billings === null || billings === undefined || billings?.length === 0) {
    return groupedBilling !== undefined && groupedBilling === true;
  }

  // Parse finalStartDate to get the month and year
  const startDate = dayjs(finalStartDate);
  const startMonth = startDate.month() + 1; // month() is 0-indexed
  const startYear = startDate.year();

  // Sort billings by year and month
  const sortedBillings = JSON.parse(JSON.stringify(billings)).sort((a, b) => {
    if (a.year === b.year) {
      return a.month - b.month;
    }
    return a.year - b.year;
  });

  // Find the matching billing rule
  let relevantBilling = sortedBillings.find(
    billing => billing.year === startYear && billing.month === startMonth,
  );

  if (!relevantBilling || finalStartDate === null) {
    // If no exact match is found, take the last one in the sorted list
    relevantBilling = sortedBillings[sortedBillings.length - 1];
  }

  // Return based on the type of the relevant billing
  if (relevantBilling.type === "unique") {
    return false;
  } else if (relevantBilling.type === "multiple") {
    return true;
  }

  // Default return value if type is not "unique" or "multiple"
  return false;
};

export const userStatusSelect = () => {
  return [
    { label: "Accès autorisé et actif", value: "active" },
    { label: "Accès non autorisé et actif", value: "inactive" },
    { label: "Archivé (non actif, non autorisé)", value: "archived" },
  ];
};
